module.exports = __webpack_public_path__ + "9c3c142ccfdf1f2be0d844f6aaec3112.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-15.png
// module id = 2592
// module chunks = 0